import HourglassTopOutlined from '@mui/icons-material/HourglassTopOutlined';
import { Alert, AlertTitle, Skeleton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type GuestJourneyPendingStateProps = {
  /** Transaction threshold GJV2 needs before it runs (drives the copy). */
  requiredTransactions: number;
};

/**
 * Pre-run empty state shown across every tab before the brand has enough
 * transaction volume for GJV2 to compute stages. Explains the threshold and
 * previews the report with skeletons. Report-level: driven by
 * Guest Journey job status `ready === false`.
 */
const GuestJourneyPendingState = ({
  requiredTransactions,
}: GuestJourneyPendingStateProps) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} data-testid="GuestJourney.Pending">
      <Alert severity="info" icon={<HourglassTopOutlined />}>
        <AlertTitle>{t('page.guestJourney.pending.title')}</AlertTitle>
        {t('page.guestJourney.pending.text', {
          required: requiredTransactions.toLocaleString(),
        })}
      </Alert>

      <Stack
        direction="row"
        spacing={2}
        data-testid="GuestJourney.Pending.CardsSkeleton"
      >
        {[0, 1, 2, 3].map(i => (
          <Skeleton key={i} variant="rounded" height={88} sx={{ flex: 1 }} />
        ))}
      </Stack>

      <Stack
        direction="row"
        flexWrap="wrap"
        gap={2}
        data-testid="GuestJourney.Pending.GridSkeleton"
      >
        {Array.from({ length: 9 }, (_unused, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            height={96}
            sx={{ flex: '1 1 30%', minWidth: 120 }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default GuestJourneyPendingState;
